<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div>
                <div class="page-kicker">Notices &amp; forms</div>
                <h2>Inspection reports</h2>
            </div>
            <div class="page-actions">
                <a class="el-button el-button--primary el-button--small" href="/inspection-report" target="_blank" rel="noopener">Write a report</a>
            </div>
        </div>
        <form-list-view form-type="inspection-report"/>
    </main-layout>
</template>

<script>
import FormListView from "./FormListView.vue";

export default {
    name: "InspectionReports",
    components: {FormListView},
}
</script>
